const actionTypes = {
  SET_SCROLLED_UP: "seneca/classroom/SET_SCROLLED_UP",
  SET_SCROLLED_DOWN: "seneca/classroom/SET_SCROLLED_DOWN",
  SET_FOCUSED_QUESTION_ID: "seneca/classroom/SET_FOCUSED_QUESTION_ID"
};

export default actionTypes;
